import { GetFrontRichiesteParams } from '@framework/api-client';
import { ExportableFileType, useAuthDownload } from '@framework/common-web';
import { useTranslation } from '@framework/i18n';
import { getNetworkErrorMessage } from '@framework/ui';
import { message } from 'antd';
import dayjs from 'dayjs';
import { useMemo } from 'react';

interface UseExportSubmissionFileOptions {
  fileType: ExportableFileType;
  query: GetFrontRichiesteParams;
  exportAll: boolean;
  setExportAll: (v: boolean) => void;
  setIsOpen: (v: boolean) => void;
}

export function useExportSubmissionFile(
  options: UseExportSubmissionFileOptions,
) {
  const { fileType, exportAll, query, setExportAll, setIsOpen } = options;
  const { t } = useTranslation();
  const requestQuery = useMemo(() => {
    if (exportAll) {
      return { ...query, pagina: 1, limite: 1000000 };
    }
    return query;
  }, [exportAll, query]);

  const result = useAuthDownload(
    fileType.getGetFrontRichiesteFileQueryOptions,
    [requestQuery],
    {
      filename: t('export.file', `Richieste_{{data}}.{{fileExtension}}`, {
        data: dayjs().format('YYYY-MM-DD_HH_mm_ss'),
        fileExtension: fileType.extension,
      }),
      onSuccess: () => {
        setExportAll(false);
        setIsOpen(false);
      },
      onError: e => {
        if (e.response?.status === 404) {
          message.error(t('export.file-non-trovato', 'File non trovato'));
          return;
        }

        message.error(getNetworkErrorMessage(e, t('export.default-errore', 'Si è verificato un problema durante il download del file. Riprovare.'))); // prettier-ignore
      },
    },
  );

  return result;
}
